import { useCallback } from "react";

import {
	createScConnectedOffViewModelUpdates,
	createScConnectedOnViewModelUpdates,
	shouldShowScConnectedToggle,
} from "@/components/features/items/edit/plan/_shared/ui/components/sc-connected";
import { useProductPlanFormModelContext } from "@/components/features/items/edit/plan/standard-plan/default/ui/_shared/context";

export const useStandardPlanScConnected = () => {
	const { viewModel, initInputModel, onSetViewModel, queryData } = useProductPlanFormModelContext();

	const shouldShow = shouldShowScConnectedToggle({
		siteControllerType: queryData.siteControllerSetting.siteControllerType,
		setUpRoomPriceByChillnn: queryData.siteControllerSetting.setUpRoomPriceByChillnn,
	});

	const onToggle = useCallback(
		(checked: boolean | undefined) => {
			if (checked) {
				onSetViewModel(createScConnectedOnViewModelUpdates(viewModel));
				return;
			}

			onSetViewModel(createScConnectedOffViewModelUpdates(viewModel, initInputModel));
		},
		[initInputModel, onSetViewModel, viewModel],
	);

	return {
		shouldShow,
		isSCConnected: viewModel.isSCConnected,
		siteControllerType: queryData.siteControllerSetting.siteControllerType,
		onToggle,
	};
};
